import { COL_OFFSET } from '@/domain/mitarbeiter/features/rotationsplan/constants';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';

interface Station {
  id: string;
  von: Date;
  bis: Date;
  getColStart(): number;
  getColEnd(): number;
}

export class ArbeitsbereichKalenderStation implements Station {
  constructor({
    von,
    bis,
    id,
    mitarbeiter,
  }: {
    von: Date;
    bis: Date;
    id: string;
    mitarbeiter: Mitarbeiter[];
  }) {
    this.mitarbeiter = mitarbeiter;
    this.von = von;
    this.bis = bis;
    this.id = id;
  }

  id: string;
  von: Date;
  bis: Date;
  mitarbeiter: Mitarbeiter[];

  getColStart(): number {
    const week = dayjs(this.von).isoWeek();
    const weekday = dayjs(this.von).isoWeekday();
    return (week - 1) * 7 + weekday + COL_OFFSET;
  }

  getColEnd(): number {
    const week = dayjs(this.bis).isoWeek();
    const weekday = dayjs(this.bis).isoWeekday();
    // Da grid-col-end exklusiv ist, müssen wir neben dem Offset noch mal 1 drauf rechnen
    return (week - 1) * 7 + weekday + COL_OFFSET + 1;
  }
}

export class MitarbeiterKalenderStation implements Station {
  constructor({
    von,
    bis,
    id,
    arbeitsbereich,
  }: {
    von: Date;
    bis: Date;
    id: string;
    arbeitsbereich: Arbeitsbereich;
  }) {
    this.arbeitsbereich = arbeitsbereich;
    this.von = von;
    this.bis = bis;
    this.id = id;
  }

  id: string;
  von: Date;
  bis: Date;
  arbeitsbereich: Arbeitsbereich;

  getColStart(): number {
    const week = dayjs(this.von).isoWeek();
    const weekday = dayjs(this.von).isoWeekday();
    return (week - 1) * 7 + weekday + COL_OFFSET;
  }

  getColEnd(): number {
    const week = dayjs(this.bis).isoWeek();
    const weekday = dayjs(this.bis).isoWeekday();
    // Da grid-col-end exklusiv ist, müssen wir neben dem Offset noch mal 1 drauf rechnen
    return (week - 1) * 7 + weekday + COL_OFFSET + 1;
  }

  getFillColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).base;
  }
}
